import React, { useEffect } from "react";
import img from '../../images/aif-img.jpg'
import AOS from "aos";
import "aos/dist/aos.css";
const About = () => {

  useEffect(() => {
    AOS.init({
      delay: 100, // values from 0 to 3000, with step 50ms
      duration: 600, // values from 0 to 3000, with step 50ms
      easing: "ease", // default easing for AOS animations
      once: false, // whether animation should happen only once - while scrolling down
      mirror: false,
    });
  }, []);


  return (
    <>
      <div className="container mt-5 pb-4">
     
        <div className="row pt-3 pb-5 gy-3">
        <div className="col-lg-5 pe-lg-4">
          <div className="video-box d-flex justify-content-center align-items-center p-3 mx-lg-0 mx-auto" style={{height:"360px", width: "360px"}}>
          <img src={img} alt="AIF"  className=" h-100 w-100 rounded-circle"/>
          </div>
          </div>
          <div className="col-lg-7   mt-5 mt-lg-3 mt-md-3 pb-2">
            <div >
                 <h2 className="heading "> Brighter Mind Inevitable Fortune Fund Scheme</h2>
         
            <p className=" text-dark-emphasis ">
            In March 2025, we are launching our Brighter Mind Inevitable Fortune Fund Scheme with the corpus of $3Million with the vision of attaining a total AUM of $100 Million in next 5 years. The Scheme is designed for investors who seek a balanced approach to growth and stability. Our investment strategy focuses on selecting companies that demonstrate strong fundamentals, sustainable competitive advantages, and consistent performance and meets our stringent stock research framework.
            </p>
            <p className=" text-dark-emphasis ">
            When you invest in the Brighter Mind AIF, you are partnering with a team that is deeply committed to your financial success. With rigorous research methodology our sole focus is on delivering higher alpha to our clients. Our transparent, client-centric approach ensures that you are always informed and confident in your investment choices. 
            </p>
            </div>
          </div>
        
        </div>
      </div>
     
 
    </>
  );
};

export default About;
